import React from 'react'
import PropTypes from 'prop-types'
import styles from './Breadcrumbs.module.scss'

const cx = (...p) => p.filter(Boolean).join(' ')

const Breadcrumbs = ({ items, label = 'Breadcrumb', className, linkComponent: Link = 'a' }) => (
  <nav aria-label={label} className={cx(styles.nav, className)}>
    <ol className={styles.list}>
      {items.map((item, i) => {
        const last = i === items.length - 1
        return (
          <li key={item.href || item.label}>
            {last || !item.href ? (
              <span className={styles.current} aria-current={last ? 'page' : undefined}>
                {item.label}
              </span>
            ) : (
              <>
                <Link className={styles.link} href={item.href} to={item.href}>
                  {item.label}
                </Link>
                <span className={styles.separator} aria-hidden="true"> /</span>
              </>
            )}
          </li>
        )
      })}
    </ol>
  </nav>
)

Breadcrumbs.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.node.isRequired,
    href: PropTypes.string,
  })).isRequired,
  label: PropTypes.string,
  className: PropTypes.string,

  linkComponent: PropTypes.elementType,
}

export default Breadcrumbs
